export default __webpack_public_path__ + "static/case-study-before-3ec61e637211bd4acc8cc5123d31de32.png";